import { ComponentsGroup as ComponentsGroupComponent, Spacing, Tag as TagComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const ComponentsGroup = styled(ComponentsGroupComponent)`
  flex-wrap: wrap;
`

export const Tag = styled(TagComponent)`
  margin-right: ${Spacing.S8};
  margin-bottom: ${Spacing.S8};
`
